export default "__VITE_ASSET__0c95e60e__"